import styled from "@emotion/styled";
import TextField from "@material-ui/core/TextField";

export const TextInput = styled(TextField)<{}>`
  width: 100%;
`;
